module.exports = __webpack_public_path__ + "static/media/header_standort.edc75dc0.jpg";